import { registerTheme } from 'echarts/core';
import { inject, injectable, singleton } from 'tsyringe';

import {
    chartDarkAlgorithm,
    chartLightAlgorithm,
    darkAlgorithm,
    lightAlgorithm,
} from '@/infra/algorithm';
import { EN_US, ZH_TW } from '@/infra/locale';
import {
    Algorithm,
    ConfigService,
    LanguageType,
    Locale,
    ThemeType,
} from '@/v1/main/domain/config';
import { ConfigRepositoryImpl } from '@/v1/main/repositories';

@injectable()
@singleton()
export class ConfigServiceImpl implements ConfigService {
    private _theme: ThemeType = ThemeType.LIGHT;
    private _algorithm: Algorithm = darkAlgorithm;
    private _language: LanguageType = LanguageType.EN_US;

    public constructor(
        @inject(ConfigRepositoryImpl)
        private _configRepo: ConfigRepositoryImpl
    ) {
        console.log('new config service');

        const init = this._configRepo.getTheme();
        this.setTheme(init);
        this.setAlgorithm(init);
        registerTheme(ThemeType.DARK, chartDarkAlgorithm());
        registerTheme(ThemeType.LIGHT, chartLightAlgorithm());
    }

    public getAlgorithm(): Algorithm {
        return this._algorithm;
    }
    private setAlgorithm(theme: ThemeType): void {
        if (theme == ThemeType.LIGHT) {
            this._algorithm = lightAlgorithm;
        } else {
            this._algorithm = darkAlgorithm;
        }
    }

    public getTheme(): ThemeType {
        return this._theme;
    }
    private setTheme(value: ThemeType): void {
        this._theme = value;
        document.body.style.colorScheme = value;
        document.body.setAttribute('data-theme', value);
    }
    public toggleTheme(): ThemeType {
        const val =
            this._theme === ThemeType.LIGHT ? ThemeType.DARK : ThemeType.LIGHT;
        this._configRepo.setTheme(val);
        this.setTheme(val);
        this.setAlgorithm(val);
        return val;
    }

    public getLocale(): Locale {
        if (this._language == LanguageType.ZH_TW) {
            return ZH_TW;
        }
        return EN_US;
    }
    public getLanguage(): LanguageType {
        return this._language;
    }
    public changeLanguage(value: LanguageType): void {
        this._language = value;
    }

    public isPwaMode(): boolean {
        const mode = ['fullscreen', 'standalone', 'minimal-ui'];
        return mode.some(
            (m) =>
                m in window.navigator ||
                window.matchMedia('(display-mode: ' + m + ')').matches
        );
    }

    public isMobileMode(): boolean {
        const mode = [
            'Android',
            'iPhone|iPad|iPod',
            'webOS',
            'Opera Mini',
            'BlackBerry',
            'Windows Phone',
        ];
        return mode.some((m) => navigator.userAgent.match(new RegExp(m, 'i')));
    }
}
